import { render, staticRenderFns } from "./SelectAddressTypeDialog.vue?vue&type=template&id=906cd6b8"
import script from "./SelectAddressTypeDialog.vue?vue&type=script&lang=js"
export * from "./SelectAddressTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports